import { sliceWhole } from './clip';

/** ant's limit on a message body, internal notes included. */
export const CHAT_BODY_MAX = 4000;

/** What the transfer note starts with: who the chat went to. */
export const transferNotePrefix = (toName: string): string =>
  `Transferred to ${toName}: `;

/** How long the agent's own note may be once the prefix is in front of it. */
export const transferNoteRoom = (toName: string): number =>
  Math.max(0, CHAT_BODY_MAX - transferNotePrefix(toName).length);

/**
 * The internal note a transfer leaves for the next agent, never longer than
 * ant's body limit: a note that does not fit is cut with an ellipsis, never
 * in the middle of an emoji.
 */
export function transferNoteText(toName: string, note: string): string {
  const text = `${transferNotePrefix(toName)}${note}`;
  return text.length > CHAT_BODY_MAX ? `${sliceWhole(text, CHAT_BODY_MAX - 1)}…` : text;
}

/**
 * The internal note Take over leaves on a chat another agent had: who has it
 * now, and from whom. Either name may be missing (ant did not say who had
 * it; an admin with no name on file).
 */
export const takeOverNoteText = (
  myName: string | null | undefined,
  fromName: string | null | undefined
): string =>
  `${myName?.trim() || 'An agent'} took over from ${fromName?.trim() || 'another agent'}`;
